// extracted by mini-css-extract-plugin
module.exports = {"container":"styles_container__1knXq","content":"styles_content__24bzO","card":"styles_card__1G2FZ","errorMsg":"styles_errorMsg__2gbTq"};